<div class="px-6 md:px-10 py-5 space-y-5">

  <!-- Loader -->
  @if(isSaving) {
    <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
      <app-loader [message]="'Procesando'"></app-loader>
    </div>
  }

  <!-- Confirm exit dialog -->
  <p-dialog header="¿Salir sin enviar?" [(visible)]="showAlert" [modal]="true" [style]="{width: '400px'}">
    <p class="text-sm">Su solicitud de dispositivos no ha sido enviada. Si sale, perderá los datos ingresados.</p>
    <ng-template #footer>
      <button pButton label="Cancelar" class="p-button-text" (click)="showAlert=false"></button>
      <button pButton label="Salir" class="p-button-danger" (click)="showAlert=false;goBack()"></button>
    </ng-template>
  </p-dialog>

  <!-- Bulk upload dialog -->
  <p-dialog header="Carga Masiva" [(visible)]="showModalFile" [modal]="true" [style]="{width: '450px'}">
    <div class="space-y-3 text-sm">
      <p>1. Descargue el formato ejemplo y llénelo con la información de sus unidades</p>
      <p>2. Cargue el archivo para ser procesado</p>
    </div>
    <ng-template #footer>
      <a pButton label="Descargar Ejemplo" icon="pi pi-download" class="p-button-outlined p-button-sm" download="CargaMasiva.xlsx" href="./assets/files/CargaMasiva.xlsx"></a>
      <button pButton label="Cargar Archivo" icon="pi pi-upload" class="p-button-sm" (click)="excelDevices.click()"></button>
    </ng-template>
  </p-dialog>

  <input type="file" class="sr-only" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    (change)="onFileChange($event)" multiple="false" #excelDevices />

  <!-- Header -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">Agregar dispositivos para unidades con placas</h2>
      <p class="text-sm text-gray mt-2 dark:text-dark-khaki-200">
        Solo podrá solicitar el alta de nuevos dispositivos para unidades con placas.
        Para tarjetas maestras o galoneras, envíe correo a <b>{{ contact?.emails?.devices }}</b>
      </p>
    </div>
    <div>
      <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">Instrucciones</h2>
      <ol class="text-sm text-gray mt-2 dark:text-dark-khaki-200 list-decimal list-inside space-y-1">
        <li>Ingrese los datos y haga clic en "Agregar" (campos con <span class="text-red-500">*</span> son obligatorios)</li>
        <li>Una vez agregadas todas las unidades, haga clic en "Enviar solicitud"</li>
      </ol>
    </div>
  </div>

  <button pButton label="Regresar a dispositivos" icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="backButton()"></button>

  <!-- Main layout -->
  <div class="grid grid-cols-1 gap-6" [ngClass]="hideForm ? 'md:grid-cols-1' : 'md:grid-cols-10'">

    <!-- Form panel -->
    <div [ngClass]="hideForm ? 'hidden' : 'md:col-span-3'" class="relative">
      <form [formGroup]="formDevice" class="space-y-5 bg-white dark:bg-crayola-blue-800 rounded-xl p-5 shadow-sm" autocomplete="off">
        <h3 class="font-semibold text-vivid-royal-700 dark:text-white text-sm uppercase tracking-wide">Datos del dispositivo</h3>

        <div class="space-y-4">
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Nombre / Usuario</label>
            <input pInputText formControlName="driverName" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Descripción</label>
            <input pInputText formControlName="brandModel" class="w-full mt-1" />
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Placa 1</label>
              <input pInputText formControlName="plate1" (keyup)="existPlate($event)"
                [inputTransformFn]="inputTransformFn" [outputTransformFn]="outputTransformFn"
                [dropSpecialCharacters]="false" [patterns]="pattern" [specialCharacters]="['-']"
                mask="K?K?K?K?K?K?K?K?K?K?" class="w-full mt-1" />
            </div>
            <div>
              <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Placa 2</label>
              <input pInputText formControlName="plate2" (keyup)="existPlate($event)"
                [inputTransformFn]="inputTransformFn" [outputTransformFn]="outputTransformFn"
                [dropSpecialCharacters]="false" [patterns]="pattern" [specialCharacters]="['-']"
                mask="K?K?K?K?K?K?K?K?K?K?" class="w-full mt-1" />
            </div>
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Número Económico</label>
            <input pInputText formControlName="ecoNumber" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Departamento</label>
            <input pInputText formControlName="department" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Límite semanal de consumo (litros)</label>
            <input pInputText formControlName="maxConsumption" mask="99999" class="w-full mt-1" />
          </div>

          <!-- Product selector -->
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"><span class="text-red-500 mr-1">*</span>Combustible autorizado</label>
            <div class="flex gap-2 mt-2">
              @for(product of allProducts; track product.value) {
                <button pButton [label]="product.product"
                  [class]="tieneProducto(product.value) ? 'p-button-sm' : 'p-button-sm p-button-outlined'"
                  (click)="addProduct(product)" type="button">
                </button>
              }
            </div>
          </div>

          <!-- Hologram toggle -->
          <div class="flex items-center justify-between">
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Requiere Holograma</label>
            <p-toggleswitch formControlName="requireHologram" />
          </div>
        </div>

        <!-- Validation errors -->
        @if(showMessageError) {
          <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messageError }}</div>
        }
        @if(plate1!.value && plate2!.value && f['plate1'].errors?.['areSame']) {
          <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">La placa principal no puede ser igual que la adicional</div>
        }

        <button pButton label="Agregar Dispositivo" icon="pi pi-plus" class="w-full p-button-sm"
          [disabled]="formDevice.invalid || cardProducts.length === 0" (click)="addDevice()" type="button">
        </button>
      </form>
    </div>

    <!-- Table panel -->
    <div [ngClass]="hideForm ? 'md:col-span-1' : 'md:col-span-7'">
      <!-- Toggle form button -->
      <button pButton [icon]="hideForm ? 'pi pi-angle-right' : 'pi pi-angle-left'" class="p-button-rounded p-button-text p-button-sm mb-3"
        (click)="hideForm=!hideForm" [pTooltip]="hideForm ? 'Mostrar formulario' : 'Ocultar formulario'">
      </button>

      <div class="flex items-center justify-between mb-3">
        <h3 class="font-semibold text-mustard-700 dark:text-mustard-400">Dispositivos a agregar ({{ devices.length }})</h3>
        <button pButton label="Carga Masiva" icon="pi pi-file-excel" class="p-button-sm p-button-outlined" (click)="showModalUpload()"></button>
      </div>

      <p-table [value]="devices" [paginator]="devices.length > 10" [rows]="10"
        styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="400px">
        <ng-template #header>
          <tr>
            @for(col of headers; track col.key) {
              <th>{{ col.textHeader }}</th>
            }
            <th class="w-[80px] text-center">Eliminar</th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            @for(col of headers; track col.key) {
              <td>{{ item[col.key] }}</td>
            }
            <td class="text-center">
              <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" (click)="clickOnRemove(item)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="headers.length + 1" class="text-center py-8 text-vivid-royal-400">
              Los dispositivos a solicitar se agregarán a esta lista
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Delivery method -->
      @if(searchHQR()) {
        <div class="mt-5 bg-white dark:bg-crayola-blue-800 rounded-xl p-4 shadow-sm">
          <h3 class="font-semibold text-mustard-700 dark:text-mustard-400 text-sm mb-3">Entrega de dispositivos</h3>
          <div class="flex gap-6">
            <div class="flex items-center gap-2">
              <input type="radio" name="shipMethod" value="2" [(ngModel)]="deliveryMethod" id="recoleccion" class="w-4 h-4" />
              <label for="recoleccion" class="text-sm dark:text-dark-khaki-200 cursor-pointer">Recolección en oficinas</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="shipMethod" value="1" [(ngModel)]="deliveryMethod" id="envio" class="w-4 h-4" />
              <label for="envio" class="text-sm dark:text-dark-khaki-200 cursor-pointer">Envío a domicilio fiscal</label>
            </div>
          </div>
        </div>
      }

      <!-- Submit -->
      <div class="flex justify-end mt-5">
        <button pButton label="Enviar solicitud" icon="pi pi-send" class="p-button-sm"
          [disabled]="devices.length === 0 || (searchHQR() && !deliveryMethod)" (click)="saveDevices()">
        </button>
      </div>
    </div>
  </div>
</div>
